export default __webpack_public_path__ + "static/media/whisper-oval-carbon-road.37cf4c82.jpg";